<template>
  <div id="LocalLifeAllOrders">
    <div class="LocalLifeAllOrders-header">
      <div class="LocalLifeAllOrders-header-top">
        <van-icon name="arrow-left" class="arrow-left" />
        <span class="ActivityList-header-title" @click="handClick()">
          {{text}}
          <van-icon name="play" :class="[hide == true ? 'play_ani' : '']" />
        </span>
        <span class="LocalLifeAllOrders-header-right">
          累积赠送积分123121.45
        </span>
      </div>
      <div class="alert" v-if="hide">
        <div class="MerchantOrder">
          <p
            class="MerchantOrder-item"
            v-for="(item, index) in order"
            :key="index"
            @click="handOrder(index,item.title)"
            :class="[select == index ? 'stylePlom' : '']"
          >
            {{ item.title }}
          </p>
        </div>
      </div>
      <div class="LocalLifeAllOrders-header-bottom">
        <div
          class="LocalLifeAllOrders-header-bottom-item"
          v-for="(item, index) in list"
          :key="index"
          @click="handSelect(index)"
        >
          <p :class="[selected == index ? 'active' : 'on']">{{ item.title }}</p>
          <p
            class="LocalLifeAllOrders-header-bottom-item-border"
            v-if="selected == index"
          ></p>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <div style="height: 109px"></div>
    <div class="ActivityList-order" v-for="(item, index) in arr" :key="index" @click="appletOrder">
      <div class="ActivityList-order-top">
        <span class="ActivityList-order-left">
          <img
            class="ActivityList-order-left-img"
            src="@/assets/localLife/美团优选@3x.png"
            alt=""
          />
          <span> 肯德基 </span>
        </span>
        <span class="ActivityList-order-right"> 待赠送 </span>
      </div>
      <div class="ActivityList-order-bottom">
        <img
          class="ActivityList-order-bottom-img"
          src="@/assets/cms/notice.png"
          alt=""
        />
        <span class="ActivityList-order-bottom-text">
          活动名称奥德赛撒大大的爱仕达as大神撒大神大奥德赛as撒大…
        </span>
      </div>
      <div class="LocalLifeAllOrders-order">
        <span>订单编号</span>
        <span class="LocalLifeAllOrders-order-content">
          <span style="color: #999999"> 1232131232231 </span>
          <span style="margin-left: 0.3rem"> 复制 </span>
        </span>
      </div>
      <div
        class="LocalLifeAllOrders-order"
        style="
          margin-top: 0.8rem;
          padding-bottom: 0.8rem;
          border-bottom: 1px solid #f7f7f7;
        "
      >
        <span>下单时间</span>
        <span class="LocalLifeAllOrders-order-content">
          <span style="color: #999999"> 2021-02-02 10:00:00 </span>
        </span>
      </div>
      <div class="IntegralEstimation">
        <span> 积分预计2021-02-02赠送 </span>
      </div>
      <div style="clear: both"></div>
      <div class="ActualPayment">
        <span class="ActualPayment-left"> 预计赠积分：20.98 </span>
        <span class="ActualPayment-right"> 实付款：¥20.98 </span>
      </div>
      <div class="DeleteOrder">删除订单</div>
      <div style="clear: both"></div>
    </div>
    <div class="order_alert" v-if="appleHide">
      <p class="order_alert_text">是否前往微信小程序查看订单？</p>
    </div>
    <van-overlay :show="hide" @click="hide = false" />
    <van-overlay class="van-overlay-move" :show="appleHide" @click="appleHide=false" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      arr: [{}, {}, {}, {}, {}, {}, {},{}],
      text:'全部订单',
      appleHide:false,
      order: [
        { title: "全部订单" },
        { title: "饿了么" },
        { title: "电影票" },
        { title: "美团团购" },
        { title: "美团外卖" },
        { title: "KFC" },
      ],
      hide: false,
      select:0,
      selected: 0,
      list: [
        {
          title: "全部",
        },
        {
          title: "待赠送",
        },
        {
          title: "已完成",
        },
        {
          title: "已失效",
        },
      ],
    };
  },
  created() {},
  methods: {
    appletOrder(){
      this.appleHide=true;
    },
    handOrder(index,name){
      this.select=index
      this.text=name
      this.hide=false;
    },
    handSelect(inx) {
      this.selected = inx;
    },
    handClick() {
      this.hide = !this.hide;
    },
  },
  beforeCreate() {
    this.$nextTick(() => {
      document.body.setAttribute("style", "background:#F5F6F7");
    });
  },
  //实例销毁之前钩子--移除body 标签的属性style
  beforeDestroy() {
    document.body.removeAttribute("style");
  },
};
</script>
<style lang="less" scoped>
#LocalLifeAllOrders {
  .van-overlay-move{

  }
  .order_alert{
    position: absolute;
    width: 80%;
    margin:0px 10%;
    z-index:100;
    top: 35%;
    height: 5rem;
    border-radius: .4rem;
    background: #fff;
    padding-bottom: 0.8rem;
    .order_alert_text{
      color:rgba(51, 51, 51, 1);
      font-weight: bold;
    }
  }
  .LocalLifeAllOrders-header {
    position: fixed;
    width: 100%;
    z-index: 2;
    top: 0;
    background: #fff;
    padding-bottom: 0.8rem;
    .alert {
      position: fixed;
      top: 65.97px;
      width: 100%;
      background: #fff;
      padding-bottom: .7rem;
 
      .MerchantOrder {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 94%;
        margin: 0 auto;
        .stylePlom{
          background: rgba(255, 246, 237, 1);
          color:rgba(255, 135, 0, 1);
          font-weight: bold;
        }
        .stylePlomOn{
           background: rgba(246, 246, 246, 1);
           color: rgba(102, 102, 102, 1);
        }
        .MerchantOrder-item {
          width: 23%;
          margin-top:.5rem;
          max-height: 2rem;
          line-height: 2rem;
          text-align: center;
          margin-right:2%;
          font-size: 0.9rem;
          border-radius: 0.3rem;
        }
      }
    }
    .LocalLifeAllOrders-header-top {
      padding: 1.4rem 0rem;
      .arrow-left {
        margin-top: 0.2rem;
      }
      .ActivityList-header-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        color: #333333;
        font-weight: bold;
        font-size: 1.1rem;
        .van-icon {
          transform: rotate(90deg);
          padding: rem(15);
          transform-origin: center center;
          color: #333333;
          font-size: 0.9rem;
          vertical-align: middle;
          margin-top: -0.3rem;
        }
        .play_ani {
          transform: rotate(-90deg);
          transform-origin: center center;
          margin-right: rem(7);
        }
      }
      .LocalLifeAllOrders-header-right {
        float: right;
        margin-right: 0.5rem;
        font-size: 0.8rem;
        color: #ff8700;
        margin-top: 0.2rem;
      }
      .arrow-left {
        margin-left: 0.6rem;
      }
    }
    .LocalLifeAllOrders-header-bottom {
      margin-top: 0.3rem;
      .LocalLifeAllOrders-header-bottom-item {
        float: left;
        width: 25%;
        text-align: center;
        .active {
          color: #333333;
          font-weight: bold;
        }
        .on {
          color: #333333;
        }
        .LocalLifeAllOrders-header-bottom-item-border {
          width: 1rem;
          height: 0.2rem;
          border-radius: 0.6rem;
          background: #ff8700;
          margin: 0 auto;
          margin-top: 0.1rem;
        }
      }
    }
  }
  .ActivityList-order {
    position: relative;
    width: 94%;
    margin: 0px 3%;
    min-height: 8rem;
    background: #fff;
    border-radius: 0.3rem;
    z-index: 1;
    margin-top: 0.8rem;
    .LocalLifeAllOrders-order {
      width: 94%;
      margin: 0px 3%;
      font-size: 0.9rem;
      color: #333333;
      .LocalLifeAllOrders-order-content {
        float: right;
      }
    }
    .DeleteOrder {
      float: right;
      max-width: 5rem;
      margin-right: 0.4rem;
      padding: 0.4rem 0.7rem;
      border: 1px solid rgba(212, 212, 212, 1);
      border-radius: 1.5rem;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 1rem;
      font-size: 0.8rem;
    }
    .ActualPayment {
      font-size: 0.9rem;
      text-align: right;
      padding-bottom: 0.9rem;
      font-weight: bold;
      .ActualPayment-left {
        color: rgba(255, 135, 0, 1);
      }
      .ActualPayment-right {
        color: rgba(51, 51, 51, 1);
        margin-left: 0.4rem;
        margin-right: 0.6rem;
      }
    }
    .IntegralEstimation {
      width: 94%;
      margin: 0.7rem 3%;
      padding: 0.6rem 0rem;
      font-size: 0.7rem;
      background: #f6f6f6;
      border-radius: 0.3rem;
      color: #333333;
      line-height: 1rem;
      span {
        margin-left: 0.5rem;
      }
    }
    .ActivityList-order-top {
      padding-top: 0.8rem;
      .ActivityList-order-left {
        margin-left: 0.8rem;
        color: #333333;
        font-size: 0.95rem;
        font-weight: bold;
        .ActivityList-order-left-img {
          width: 1.5rem;
          vertical-align: middle;
        }
      }
      .ActivityList-order-right {
        float: right;
        margin-right: 0.8rem;
        color: #999999;
        font-size: 0.95rem;
      }
    }
    .ActivityList-order-bottom {
      color: #333333;
      padding: 0.7rem 0rem;
      .ActivityList-order-bottom-img {
        width: 5rem;
        height: 5rem;
        margin-left: 0.7rem;
        border-radius: 0.3rem;
        vertical-align: top;
      }
      .ActivityList-order-bottom-text {
        display: inline-block;
        max-width: 70%;
        margin-left: 0.5rem;
        line-height: 1.2rem;
        font-size: 0.95rem;
        font-weight: bold;
      }
    }
  }
}
</style>
